// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__3WXY1","name":"ConsentHeader_name__3Hj25","birthday":"ConsentHeader_birthday__2jJl9","skeleton":"ConsentHeader_skeleton__1mm38"};